module.exports = __webpack_public_path__ + "static/credfinshots-73a4961abad0e7c64fae6df5196370fe.png";